import { get } from "./api_helper"

export async function exportRecords(records) {
  return get("/cms/tree/listing/report/export", { params: { ids: records } })
}

export async function exportRecordById(treeListingId) {
  return get(`/cms/tree/listing/${treeListingId}/report/export`)
}
